import { EXPENSE_RETURN_REASON_LABEL } from '../../constants/expense-return-reason.map';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { Expense } from '../../models/expense.model';
import { ServiceDetailLinkService } from '../../services/service-detail-link.service';

/** Resultado que devuelve el panel al cerrarse. */
export type ExpenseDetailResult = 'edit';

/**
 * Panel lateral de sólo lectura con el detalle de un gasto.
 *
 * «Editar gasto» no abre el formulario aquí: cierra el panel devolviendo `'edit'`
 * para que el contenedor haga la transición, de modo que nunca hay dos offcanvas
 * apilados.
 */
@Component({
  selector: 'app-expense-detail-sidebar',
  templateUrl: './expense-detail-sidebar.component.html',
  styleUrls: ['../expense-panel.css', './expense-detail-sidebar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpenseDetailSidebarComponent {
  /**
   * Clave del motivo de la devolución, o null si el gasto no lo lleva.
   *
   * Se traduce aquí y no se guarda traducido: así el motivo se lee en el idioma
   * de quien mira, y no en el del operador que lo eligió.
   */
  protected get returnReasonLabelKey(): string | null {
    const code = this.expense?.review?.returnReasonCode;

    return code ? EXPENSE_RETURN_REASON_LABEL[code] : null;
  }
  @Input({ required: true }) expense!: Expense;

  /**
   * Enlace al servicio del gasto. Se desactiva al abrir el panel desde el
   * desglose de precio, donde el usuario ya está en ese servicio.
   */
  @Input() showServiceLink = true;

  constructor(
    private readonly activeOffcanvas: NgbActiveOffcanvas,
    private readonly serviceDetailLink: ServiceDetailLinkService
  ) {}

  protected canOpenService(): boolean {
    return this.serviceDetailLink.canOpen(this.expense.orderHash);
  }

  /** El panel se queda abierto: el servicio va a una pestaña nueva. */
  protected openService(): void {
    this.serviceDetailLink.open(this.expense.orderHash);
  }

  protected requestEdit(): void {
    this.activeOffcanvas.close('edit' satisfies ExpenseDetailResult);
  }

  protected close(): void {
    this.activeOffcanvas.dismiss();
  }
}
